import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

/**
 * Loads every message template (admin-only) for the visual editor.
 */
export const useMessageTemplates = () => {
	const queryClient = useQueryClient();
	const queryKey = ["message-templates"];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getMessageTemplates();
			return response ?? [];
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};

/**
 * Loads the list of variables available inside templates (the columns of
 * user_state_tmp). Cached aggressively: the schema rarely changes.
 */
export const useTemplateVariables = () => {
	const queryKey = ["message-template-variables"];

	return useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getMessageTemplateVariables();
			return response ?? [];
		},

		staleTime: 1000 * 60 * 30,
	});
};
